export const CWY_COLORS = {
  red: '#CC1B1B',
  darkNavy: '#131921',
  navy: '#232f3e',
  navyLight: '#37475a',
  teal: '#007185',
  tealDark: '#005f6b',
  tealLight: '#00a8b5',
  yellow: '#FFD814',
  yellowHover: '#F7CA00',
  amber: '#febd69',
  
  // Themeable colors via CSS custom properties
  pageBg: 'var(--cwy-pageBg, #F7F6F4)',
  bg: 'var(--cwy-bg, #F7F6F4)',
  cardBg: 'var(--cwy-cardBg, rgba(255,255,255,0.55))',
  glassBg: 'var(--cwy-glassBg, rgba(255,255,255,0.55))',
  glassBgRaised: 'var(--cwy-glassBgRaised, rgba(255,255,255,0.8))',
  border: 'var(--cwy-border, rgba(20,21,26,0.08))',
  borderSoft: 'var(--cwy-borderSoft, rgba(20,21,26,0.06))',
  textPrimary: 'var(--cwy-textPrimary, #15161A)',
  textSecondary: 'var(--cwy-textSecondary, #5C5D63)',
  textFaint: 'var(--cwy-textFaint, #8B8C92)',
  redCore: 'var(--cwy-redCore, #CC1B1B)',
  redWash: 'var(--cwy-redWash, rgba(204,27,27,0.08))',
  verified: 'var(--cwy-verified, #1E9D63)',
  navBg: 'var(--cwy-navBg, rgba(247,246,244,0.75))',
  ambient1: 'var(--cwy-ambient1, rgba(204,27,27,0.05))',
  ambient2: 'var(--cwy-ambient2, rgba(51,196,126,0.05))',
  
  priceRed: '#B12704',
  successGreen: '#007600',
};
